import { merge, isFunction } from 'lodash';

export default {
  props: {
    // BEGIN::Removed.by.KWShin.2024.03.12.
    // title: String,
    // FINISH::Removed.by.KWShin.2024.03.12.
    // BEGIN::Added.by.KWShin.2022.02.22.
    // BEGIN::Modified.by.KWShin.2025.11.28.
    // 이거 Java 쪽에서도 사용한다. 이름을 descendants로 바꾼다.
    // instances: Array,
    descendants: Array,
    // FINISH::Modified.by.KWShin.2025.11.28.
    // FINISH::Added.by.KWShin.2022.02.22.
  },
  data() {
    return {
      // BEGIN::Added.by.KWShin.2022.02.22
      chartColor: {
        merge: '#d78407',
        bgDark: '#242424',
        bgLight: '#F7F7F7',
        textDark: '#DDDDDD',
        textLight: '#6B717D',
      },
      // FINISH::Added.by.KWShin.2022.02.22
      init: {
        xAxis: {
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    };
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.isDark;
    },
    // BEGIN::Added.by.KWShin.2024.02.22.
    activeColor() {
      // User.vue에는 props 'descendents'가 넘어가지 않는다.
      if (this.descendants == undefined) return this.chartColor.merge;

      const activeInsts = this.descendants.filter(d => d.active);
      if (activeInsts.length == 1) return activeInsts[0].color;
      else return this.chartColor.merge;
    },
    // FINISH::Added.by.KWShin.2024.02.22.
    options() {
      const options = {
        title: {
          text: `${this.title}`,
          textStyle: {
            fontSize: 15,
            // BEGIN::Modified.by.KWShin.2024.02.22.
            // color: this.isDark ? '#DDDDDD' : '#6B717D',
            color: this.isDark ? this.chartColor.textDark : this.chartColor.textLight,
            // FINISH::Modified.by.KWShin.2024.02.22.
          },
          top: '10%',
          x: 'center',
          y: 'top',
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            // BEGIN::Modified.by.KWShin.2024.02.22.
            // color: ['#777777'],
            color: [this.activeColor],
            // FINISH::Modified.by.KWShin.2024.02.22.
            type: 'liquidFill',
            radius: '55%',
            amplitude: this.data.type == 'percent' ? '5%' : '0%',
            waveAnimation: this.data.type == 'percent',
            shape: this.shape || 'roundRect', // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'. Or, an SVG path starting with 'path://'
            center: ['50%', '45%'],
            backgroundStyle: {
              // BEGIN::Modified.by.KWShin.2024.02.22.
              // color: this.isDark ? '#ddd' : '#6b717d',
              color: this.isDark ? this.chartColor.bgDark : this.chartColor.bgLight,
              // FINISH::Modified.by.KWShin.2024.02.22.
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 1)',
              shadowBlur: 20,
            },
            outline: {
              show: false,
            },
            label: {
              normal: {
                formatter: param => {
                  const contents = [];
                  contents.push(param.data.data);
                  contents.push(param.data.data && param.data.unit ? ` ${param.data.unit}` : '');
                  return contents.join('');
                },
                textStyle: {
                  // BEGIN::Modified.by.KWShin.2024.02.22.
                  // color: this.isDark ? '#ddd' : '#6b717d',
                  color: this.activeColor,
                  // FINISH::Modified.by.KWShin.2024.02.22.
                  fontSize: 20,
                },
              },
            },
            data: [
              {
                data: this.data.value,
                value: this.data.type == 'percent' ? this.data.value / 100 : 0,
                type: this.data.type,
                unit: this.data.type == 'percent' ? '%' : this.data.unit,
              },
            ],
          },
        ],
      };
      return merge({}, options, isFunction(this.getSettings) ? this.getSettings() : undefined);
    },
  },
};
